import type { Goal } from "@/models/Goal.model";

/**
 * Whether a goal falls under a main group (a top-level node of its curriculum's
 * structure, identified by that node's path, e.g. 'NL' or '1').
 *
 * Case-insensitive on both sides. A goal belongs to the group when its parent path
 * *is* the group (GO! Navigator numbers goals directly under the curriculum: parent
 * path 'NL') or starts with it as a dotted prefix ('NL.003', '1.2.3').
 */
export function goalBelongsToMainGroup(goal: Goal, mainGroup: string): boolean {
	const group = mainGroup.toLowerCase();
	const parentPath = goal.sourceParentPath?.toLowerCase();

	if (parentPath) {
		return parentPath === group || parentPath.startsWith(group + '.');
	}

	// OVSG attitudes have no sourceParentPath, but their sourcePathId starts with the main group.
	const pathId = goal.sourcePathId?.toLowerCase();
	return !!pathId && pathId.startsWith(group + '.');
}
